import { API_URL } from '../config/apiConfig';

// Get trainer vacations for a specific affiliate and year
export const getTrainerVacations = async (affiliateId, year) => {
    const token = localStorage.getItem('token');
    const response = await fetch(
        `${API_URL}/trainer-vacations?affiliateId=${affiliateId}&year=${year}`,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );

    if (!response.ok) {
        throw new Error('Failed to fetch trainer vacations');
    }

    return await response.json();
};

// Create a new vacation
export const createTrainerVacation = async (trainerId, affiliateId, startDate, endDate) => {
    const token = localStorage.getItem('token');
    
    // Format dates as date-only strings (yyyy-mm-dd) to avoid timezone issues
    const formatDateOnly = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    const response = await fetch(`${API_URL}/trainer-vacations`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            trainerId,
            affiliateId,
            startDate: formatDateOnly(startDate),
            endDate: formatDateOnly(endDate)
        })
    });

    if (!response.ok) {
        throw new Error('Failed to create vacation');
    }

    return await response.json();
};

// Update an existing vacation
export const updateTrainerVacation = async (vacationId, startDate, endDate) => {
    const token = localStorage.getItem('token');
    
    // Format dates as date-only strings (yyyy-mm-dd) to avoid timezone issues
    const formatDateOnly = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    const response = await fetch(`${API_URL}/trainer-vacations/${vacationId}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            startDate: formatDateOnly(startDate),
            endDate: formatDateOnly(endDate)
        })
    });

    if (!response.ok) {
        throw new Error('Failed to update vacation');
    }

    return await response.json();
};

// Delete a vacation
export const deleteTrainerVacation = async (vacationId) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/trainer-vacations/${vacationId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Failed to delete vacation');
    }

    return await response.json();
};

